import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import ComposerPostPreview from 'flarum/forum/components/ComposerPostPreview';
/**
 * The message being written, as it will be published - see
 * addPostPreview.ts. Core's own ComposerPostPreview does the rendering, the
 * same one the post stream shows under a reply being written: the same
 * formatter, and what extensions add to it (mentions, emoji, links to the
 * forum's own discussions). It keeps following the composer, so the modal
 * stays right if left open while the text changes behind it.
 */
export default class PostPreviewModal extends Modal {
  className() {
    return 'PostPreviewModal Modal--large';
  }
  title() {
    return app.translator.trans('champis-forum.forum.post_preview.title');
  }
  content() {
    const content = app.composer.fields?.content() ?? '';
    return m("div", {
      className: "Modal-body"
    }, this.attrs.discussionTitle ? m("h2", {
      className: "PostPreviewModal-discussionTitle"
    }, this.attrs.discussionTitle) : null, content.trim() ? m(ComposerPostPreview, {
      className: "Post-body PostPreviewModal-post",
      composer: app.composer
    }) : m("p", {
      className: "PostPreviewModal-empty"
    }, app.translator.trans('champis-forum.forum.post_preview.empty')));
  }
}
flarum.reg.add('champis-forum', 'forum/components/PostPreviewModal', PostPreviewModal);